import axiosClient from "../axios-client";
import { toastMessage } from "../toaster/toaster";

// REDUX IMPORTS
import { getAgentSuccess, getAdminActionSuccess, getAgentDetailsStart, getAgentDetailsSuccess } from "../reducers/agentReducer";
import { changeLoaderStatus } from "../actions/loaderAction";


// ===============================================================================
// =================================== GET API ===================================
// ===============================================================================

export const agentsListGet = async (dispatch) => {
    return axiosClient
        .get("/agent/agents")
        .then((res) => {
            dispatch(getAgentSuccess(res.data));
        })
        .catch((error) => {
            toastMessage("Astrologers records not found", "error");
            return error;
        });
};


export const allAgentsGet = async (dispatch) => {
    if (dispatch) {
        changeLoaderStatus(dispatch, true)
    }
    return axiosClient
        .get("/agent/v2/agents")
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            toastMessage("Astrologers not found", "error");
            return error;
        }).finally(() => {
            setTimeout(() => {
                if (dispatch) {
                    changeLoaderStatus(dispatch, false)
                }
            }, 500);
        })
};


export const agentServicesGet = async (dispatch, id) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .get(`/agent/agent-services?agent_id=${id}`)
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            toastMessage("Astrologer serviecs not found", "error");
            return error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


export const getAgentWorkHistory = async () => {
    return axiosClient
        .get("/agent/agent_stats")
        .then((res) => res.data)
        .catch((error) => {
            toastMessage("Astrologer stats not found", "error");
            return error;
        });
};


export const agentByIdGet = async (dispatch, id) => {
    changeLoaderStatus(dispatch, true);
    changeLoaderStatus(dispatch, true);
    dispatch(getAgentDetailsStart())
    return axiosClient
        .get(`/agent/agent_detail/${id}`)
        .then((res) => {
            dispatch(getAgentDetailsSuccess(res?.data))
            return res?.data;
        })
        .catch((error) => {
            toastMessage("Astrologer information not found", "error");
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const getAdminActions = async (dispatch, id) => {
    return axiosClient
        .get(`/agent/admin_actions/${id}`)
        .then((res) => {
            dispatch(getAdminActionSuccess(res?.data))
        })
        .catch((error) => {
            toastMessage("No admin actions available", "error");
            return error;
        });
};


export const filterAgent = async (status) => {
    return axiosClient
        .get(`/agent/filter_agents/${status}`)
        .then((res) => {
            return res
        })
        .catch((error) => {
            console.log(error);
        })
};


export const agentDetailsGet = async (dispatch, id) => {
    return axiosClient
        .get(`/agent/v2/agent_detail/${id}`)
        .then((res) => {
            return res?.data;
        })
        .catch((error) => {
            toastMessage("Astrologer information not found", "error");
            throw error;
        });
};



export const agentParamVariable = async (dispatch, data) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/agent/agent-param-variables`, data)
        .then((res) => {
            return res?.data;
        })
        .catch((error) => {
            toastMessage("Astrologer params variable not found", "error");
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const getAgentServiceActions = async (dispatch) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .get(`/agent/agent_service_actions`)
        .then((res) => {
            return res?.data;
        })
        .catch((error) => {
            toastMessage("Astrologer update service actions not found", "error");
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const getAllSessions = async (dispatch, filters = {}) => {
    changeLoaderStatus(dispatch, true);
    // Construct query parameters dynamically
    const params = new URLSearchParams();

    if (filters.status) params.append("status", filters.status);
    if (filters.start_date) params.append("start_date", filters.start_date);
    if (filters.end_date) params.append("end_date", filters.end_date);

    const queryString = params.toString();
    const url = `/agent/sessions${queryString ? `?${queryString}` : ''}`;

    return axiosClient
        .get(url)
        .then((res) => {
            return res?.data;
        })
        .catch((error) => {
            toastMessage("Session not retrieved due to some error", "error");
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};

// ===============================================================================
// =================================== POST API ==================================
// ===============================================================================

export const agentStatusUpdate = async (dispatch, id, data) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .post(`/agent/agent_update/${id}`, data)
        .then((res) => {
            toastMessage("Action performed successfully", "success");
        })
        .catch((error) => {
            toastMessage("Something went wrong", "error");
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const createAgentService = async (dispatch, id, data) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .post(`/agent/create_service/${id}`, data)
        .then((res) => {
            toastMessage("Service created successfully", "success");
        })
        .catch((error) => {
            toastMessage("Service not created due to some error", "error");
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


// ===============================================================================
// =================================== PUT API ==================================
// ===============================================================================

export const updateAgentStatus = async (dispatch, id, statusData) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .put(`/agent/agent-status?agent_id=${id}`, statusData)
        .then((res) => {
            toastMessage("Agent status updated successfully", "success");
        })
        .catch((error) => {
            toastMessage("Agent status not updated, due to some error", "error");
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const updateAgentBookingStatus = async (dispatch, id, status) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .put(`/agent/agent-booking-status?agent_id=${id}&status=${status}`)
        .then((res) => {
            toastMessage("Agent status updated successfully", "success");
        })
        .catch((error) => {
            toastMessage("Agent status not updated, due to some error", "error");
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const updateAgentServiceDetails = async (dispatch, id, data) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .put(`/agent/agent-service/${id}`, data)
        .then((res) => {
            toastMessage("Agent service details updated successfully", "success");
        })
        .catch((error) => {
            toastMessage("Agent service details not updated, due to some error", "error");
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const updateAdminActionDetails = async (dispatch, id, data) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .put(`/agent/admin-action/${id}`, data)
        .then((res) => {
            toastMessage("Admin action details updated successfully", "success");
        })
        .catch((error) => {
            toastMessage("Admin action details not updated, due to some error", "error");
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const updateAdminActionStatus = async (dispatch, id, status) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .put(`/agent/admin-actions/${id}/${status}`)
        .then((res) => {
            toastMessage("Admin action status updated successfully", "success");
        })
        .catch((error) => {
            toastMessage("Admin action status not updated, due to some error", "error");
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};


export const agentUpdateDetails = async (dispatch, id, data) => {
    changeLoaderStatus(dispatch, true);
    return axiosClient
        .put(`/agent/update/${id}`, data)
        .then((res) => {
            toastMessage("Details updated successfully", "success");
            return res?.data;
        })
        .catch((error) => {
            toastMessage("Details not updated", "error");
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false);
            }, 500);
        });
};

export const agentSessionStatusUpdate = async (sessionId, data) => {
    return axiosClient
        .put(`/agent/session-status?session_id=${sessionId}`, data)
        .then((res) => {
            toastMessage("Session marked as not conducted successfully", "success");
        })
        .catch((error) => {
            toastMessage("Something went wrong", "error");
        })
};


// ── Redesigned Onboarding screen: server-side list contract ────────────────────

/** One page of partners. `params` comes straight from useListState. */
export const listPartners = async (params) => {
    const qs = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
        if (v !== null && v !== undefined && v !== "") qs.set(k, v);
    });
    return axiosClient
        .get(`/agent/v3/agents?${qs}`)
        .then((res) => res?.data)
        .catch((error) => {
            toastMessage("Partners could not be loaded", "error");
            throw error;
        });
};

/** Row counts for the saved-view tabs. Decorative, so failures resolve empty. */
export const getPartnerViewCounts = async () =>
    axiosClient
        .get(`/agent/v3/agents/counts`)
        .then((res) => res?.data || {})
        .catch(() => ({}));

const listGetter = (path) => async (params) => {
    const qs = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
        if (v !== null && v !== undefined && v !== "") qs.set(k, v);
    });
    return axiosClient.get(`${path}?${qs}`).then((res) => res?.data);
};

const countsGetter = (path) => async () =>
    axiosClient.get(path).then((res) => res?.data || {}).catch(() => ({}));

export const listServiceActions = listGetter("/agent/v3/service-actions");
export const getServiceActionCounts = countsGetter("/agent/v3/service-actions/counts");

export const listBankApprovals = listGetter("/agent/v3/bank-approvals");
export const getBankApprovalCounts = countsGetter("/agent/v3/bank-approvals/counts");

export const listSessions = listGetter("/agent/v3/sessions");
export const getSessionCounts = countsGetter("/agent/v3/sessions/counts");
